import React, { useEffect } from 'react'

import Flex from '../Flex'
import Text from '../Text'
import { useCountdown } from '../../hooks/useCountdown'
import { CountdownProps } from './Countdown.types'

const Countdown: React.FC<CountdownProps> = ({
  endDate,
  onExpired,
  format = 'dd:hh:mm:ss',
  color = 'white',
  backgroundColor = 'red50',
  interval = 1000,
}) => {
  const { days, hours, minutes, seconds, isExpired } = useCountdown(endDate, { interval, format })

  const getCountdown = () => {
    if (isExpired) {
      return format
        .split(':')
        .map(() => '00')
        .join(' : ')
    } else if (format === 'dd:hh:mm') {
      return [days, hours, minutes].join(' : ')
    } else if (format === 'hh:mm:ss') {
      return [hours, minutes, seconds].join(' : ')
    } else if (format === 'hh:mm') {
      return [hours, minutes].join(' : ')
    } else if (format === 'mm:ss') {
      return [minutes, seconds].join(' : ')
    } else {
      return [days, hours, minutes, seconds].join(' : ')
    }
  }

  useEffect(() => {
    if (isExpired && onExpired) onExpired()
  }, [isExpired])

  return (
    <Flex
      backgroundColor={backgroundColor}
      padding='2.5px 17px'
      borderRadius='100px'
      maxWidth='max-content'
    >
      <Text color={color} weight='bold'>
        {getCountdown()}
      </Text>
    </Flex>
  )
}

export default Countdown
